// Keep product URL clean (remove ?variant=)
document.addEventListener('DOMContentLoaded', function () {
  const url = new URL(window.location.href);

  if (url.searchParams.has('variant')) {
    url.searchParams.delete('variant');
    window.history.replaceState({}, document.title, url.pathname);
  }
});
